import { Component, Inject } from '@angular/core';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { PatientService } from '../../../services/patient.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-patient-edit-dialog',
  templateUrl: 'patient-edit-dialog.component.html',
  styleUrls: ['./patient-edit-dialog.component.css']
})
export class PatientEditDialogComponent {

  patientId?: number;
  firstName: string;
  lastName: string;
  document: string;

  constructor(public dialogRef: MatDialogRef<PatientEditDialogComponent>
    , @Inject(MAT_DIALOG_DATA) public data: any) {
      this.patientId = this.data.patientId;
      this.firstName = this.data.firstName;
      this.lastName = this.data.lastName;
      this.document  = this.data.document;
  }

  onClose($event): void {
    if (!$event) {
      this.dialogRef.close(false);
    } else {
      this.dialogRef.close($event);
    }
  }
}
